import getSymbolFromCurrency from 'currency-symbol-map';
import { KoobButton, KoobInputNumber, KoobPopover } from '@koob/ui';

// KD-3391: popover version of the price-range filter (replaces the
// ExperienceFiltersPriceRange modal); changes apply immediately.
const PriceRangePopover = ({
  translation,
  value = [0, null],
  onChange,
  currency,
}) => {
  const [minPrice, maxPrice] = value ?? [0, null];
  const symbol = currency ? getSymbolFromCurrency(currency) : null;
  const isActive = (minPrice ?? 0) > 0 || maxPrice != null;

  return (
    <KoobPopover
      trigger={
        <KoobButton variant="secondary" rounded="full">
          <i className="fa-light fa-tag text-gray-500" />
          <span>{translation('search.priceRange')}</span>
          {isActive && (
            <i
              className="fa-regular fa-circle-xmark text-gray-500"
              onClick={(event) => {
                event.stopPropagation();
                onChange([0, null]);
              }}
            />
          )}
        </KoobButton>
      }
    >
      <div className="space-y-4">
        <div className="space-y-1.5">
          <div className="text-sm font-medium text-gray-700">
            {translation('priceRange.minPrice')}
          </div>
          <KoobInputNumber
            min={0}
            value={minPrice}
            emptyValue={0}
            onValueChange={(min) => onChange([min ?? 0, maxPrice ?? null])}
            iconRight={symbol ? <span>{symbol}</span> : undefined}
          />
        </div>

        <div className="space-y-1.5">
          <div className="text-sm font-medium text-gray-700">
            {translation('priceRange.maxPrice')}
          </div>
          <KoobInputNumber
            min={0}
            value={maxPrice}
            onValueChange={(max) => onChange([minPrice ?? 0, max])}
            iconRight={symbol ? <span>{symbol}</span> : undefined}
          />
        </div>
      </div>
    </KoobPopover>
  );
};

export default PriceRangePopover;
